module.exports = __webpack_public_path__ + "static/media/changePayment.05dd88b4.svg";